<template>
  <div class="protect-measures-main" :class="{ 'protect-measures-main-mobile': isMobile}">
    <Base-title title="贝壳隐私保护措施"></Base-title>
    <MeasuresSwiper></MeasuresSwiper>
  </div>
</template>
<script>
  export default {
    // 贝壳隐私保护措施
    name: 'ProtectMeasures'
  };
</script>
<style lang="scss" scoped>
  .protect-measures-main {
    display: flex;
    align-items: center;
    padding-top: 0.77rem;
    width: 100%;
    height: 7.56rem;
    flex-direction: column;
    background: #f6faff;
  }
  .protect-measures-main-mobile {
    padding-top: 2.1rem;
    height: 27.39rem;
  }
</style>
